import React from 'react';
import {connect} from 'react-redux';
import {Col, Container, Modal, Row} from 'react-bootstrap';
import {utilActions} from '../../_actions';
import {infoTablaDefault, UserDP} from '../../_helpers';
import {userService} from '../../_services';
import MaterialTable from 'material-table';
import {Field, Form, Formik} from 'formik';
import Moment from 'react-moment';
import InfoUsuario from './forms/InfoUsuario';
import {empresaActions} from '../../_actions/empresa.actions';
import Select from 'react-select';
import {FormUsuarioAdmin} from './forms/FormUsuarioAdmin';
import {FormCambiarPassword} from '../Perfil';
import authService from '../../_services/authService';
import ReactTooltip from 'react-tooltip';

const tableRef4 = React.createRef();
const _ = require('lodash');

class AdmUsuarios extends React.Component {

    constructor(props) {
        super(props);
        this.state.nuevo = _.clone(infoTablaDefault);
    }

    state = {
        show: false,
        alert: undefined,
        showEquipo: false,
        showUsuario: false,
        showPassword: false
    };

    componentDidMount() {
        if (this.props.empresas === undefined) this.props.traerEmpresas();
    }

    handleClose = () => {
        this.setState({
            show: false,
            showEquipo: false,
            showUsuario: false,
            showPassword: false
        });
        this.actualizar();
    };

    handleMasInfo = (usuario) => {
        this.setState({
            showUsuario: true,
            usuario: usuario
        });
    };

    asignarEquipo = (usuario) => {
        this.setState({
            showEquipo: true,
            usuario: usuario
        });
    };

    agregarEmpresa = (usuario) => {
        this.setState({
            showEmpresa: true,
            usuario: usuario
        });
    };

    cerrarAlert = () => {
        this.setState({vista: {}, alert: null});
    }

    actualizar = () => {
        tableRef4.current && tableRef4.current.onQueryChange();
    }

    handleShow = () => {
        this.setState({show: true});
    };

    actualizarPageSize = (newPageSIze) => {
        if (tableRef4.current) {
            tableRef4.current.dataManager.changePageSize(newPageSIze)
        }
    };

    buscarData = (query, completo) => {
        const newThis = this;
        return new Promise((resolve, reject) => {
            let nuevo = {
                infoTabla: {
                    resultadoCompleto: completo,
                    search: query.search,
                    page: query.page,
                    limit: query.pageSize,
                    skip: Math.floor((query.pageSize * query.page)),
                    orderBy: query.orderBy ? query.orderBy : '',
                    order: query.orderDirection ? query.orderDirection : ''
                }
            };

            if (!completo)
                newThis.setState({nuevo: nuevo});

            let dataBusqueda = newThis.state.values ? Object.assign(newThis.state.values, nuevo) : nuevo;

            userService.buscarUsuarios(dataBusqueda)
                .then(
                    data => {
                        resolve({
                            data: data.listado ? data.listado.listado : [],
                            page: query.page,
                            totalCount: data.listado ? data.listado.total : 0
                        })
                        this.actualizarPageSize(query.pageSize);
                    }
                );
        })
    }

    render() {
        const {empresas} = this.props;

        const header = [
            {title: 'Username', field: 'username'},
            {title: 'Nombre', field: 'nombre'},
            {title: 'Empresa', field: 'empresa.nombre'},
            {title: 'Mail', cellStyle: {width: '10%'}, field: 'mail'},
            {
                title: 'Fecha', field: 'createdDate',
                render: row =>
                    <Moment date={row.createdDate} format="DD/MM/YYYY hh:mm"/>
            },
            {
                title: 'Habilitado', field: 'enabled',
                render: row =>
                    row.enabled ? 'Si' : 'No'
            },
            {
                title: 'Roles', field: 'enabled',
                render: row =>
                    <>
                        {row.roles?.map((item, index) =>
                            <span>{authService.formatRol(item.authority)}</span>
                        )}
                    </>
            },
            {
                title: 'Acciones', cellStyle: {width: '30%'},
                render: row =>
                    <>
                        <a data-tip data-for='info' className="btns btns-link" onClick={() => this.handleMasInfo(row)}>
                        <span className="material-icons text-fucsia">info</span>
                        </a>
                        <ReactTooltip place="bottom" id='info' aria-haspopup='false' >
                        <span>Info Usuario</span>
                        </ReactTooltip>

                        <a data-tip data-for='pass' className="btns btns-link"  onClick={() => this.setState({showPassword: true, usuario: row})}>
                        <span className="material-icons text-info">lock</span>
                        </a>
                        <ReactTooltip place="bottom" id='pass' aria-haspopup='false' >
                        <span>Cambiar contraseña</span>
                        </ReactTooltip> 
                    </>

            }
        ];

        const options = {
            search: true,
            sorting: true
        }

        let inic = {
            nombre: '',
            empresa: {id: ''}
        }

        return (
            <div className="main-content">
                <Container fluid>
                    <Row className="mb-5 mt-5">
                        <Col xs="12">
                            <button className="btns btns-iot text-white" onClick={() => this.handleMasInfo(undefined)}>
                                <i
                                    className="material-icons-outlined icon-image-preview align-top">person_add</i> Nuevo
                                Usuario
                            </button>
                        </Col>

                    </Row>
                    <Row>
                        <Col>
                            <div className="mt-5">
                                <Formik
                                    enableReinitialize={true}
                                    initialValues={inic}
                                    onSubmit={(values) => {
                                        this.setState({
                                            values: values
                                        }, this.actualizar);
                                    }}>
                                    {({values, setFieldValue}) => (
                                        <Form>
                                            <Row className="justify-content-center">
                                                <Col lg={6} xs={12}>
                                                    <label htmlFor="Estado">
                                                        Nombre / Email
                                                    </label>
                                                    <Field name='nombre'/>
                                                </Col>
                                                <Col xs="6">
                                                    <label className="font-weight-bold"
                                                           htmlFor="asignado">Empresa </label>
                                                    <Select
                                                        isClearable
                                                        isMulti={false}
                                                        value={empresas ? empresas.filter(obj => values.empresa?.id == obj.id) : []}
                                                        name={`empresa`}
                                                        getOptionLabel={option => `${option.nombre}`}
                                                        getOptionValue={option => option.id}
                                                        onChange={so => {
                                                            setFieldValue(`empresa`, so ? so : undefined)
                                                        }}
                                                        isSearchable={true}
                                                        placeholder="Seleccione"
                                                        options={empresas}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="justify-content-center mb-4">
                                                <Col xs={12} lg={3}
                                                     className="mt-4 d-flex justify-content-lg-end justify-content-sm-center">
                                                    <button className="btn-block btns-primary btns" type="submit"><i
                                                        className="fas fa-search"></i> Buscar
                                                    </button>
                                                </Col>
                                            </Row>
                                        </Form>

                                    )}
                                </Formik>
                            </div>
                            <hr></hr>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs="12">
                            <MaterialTable
                                title='Usuarios'
                                columns={header}
                                tableRef={tableRef4}
                                data={query =>
                                    this.buscarData(query, false)
                                }
                                options={options}
                                localization={utilActions.traerPalabrasTabla()}
                                detailPanel={rowData => {
                                    return (
                                        <UserDP rowData={rowData}/>
                                    )
                                }}
                                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                            />

                        </Col>
                    </Row>
                </Container>
                {this.state.show && <Modal show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header className="bg-fucsia text-white" closeButton>
                        <Modal.Title>Detalles usuario</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <InfoUsuario usuario={this.state.usuario} handleClose={this.handleClose}/>
                    </Modal.Body>
                </Modal>}


                {this.state.showUsuario &&
                <FormUsuarioAdmin show={this.state.showUsuario} handleClose={this.handleClose}
                                  usuario={this.state.usuario}/>}

                {this.state.showPassword &&
                <FormCambiarPassword show={this.state.showPassword} esRecuperacion={false} esAdmin={true}
                                     usuarioId={this.state.usuario.id} handleClose={() => this.handleClose()}/>}
                {this.state.alert}
            </div>
        );
    }
}

function mapState(state) {
    const {empresas} = state.empresa;
    return {empresas};

}

const actionCreators = {
    traerEmpresas: empresaActions.traerEmpresas
}

const connectedAdmUsuarios = connect(mapState, actionCreators)(AdmUsuarios);
export {connectedAdmUsuarios as AdmUsuarios};